import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})
export class RecruitService {

  constructor(
    private restful: RestfulService,
  ) { }

  private extractData(res: Response) {
    const body = res;
    return body || [ ];
  }

  private handleErrorPromise(error: Response | any) {
    console.log(error.message || error);
    return Promise.reject(error.message || error);
  }

  // #region "구인"
  // 구인 게시판 리스트를 가져온다.
  getBoardJobOfferList(params: any): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'job',
        version: '1.0',
        action: 'getBoardJobOfferList'
      }, {
        no: params.no,
        row: params.row,
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 구인 게시판 상세정보를 가져온다.
  getBoardJobOfferDetail(params: any): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'job',
        version: '1.0',
        action: 'getBoardJobOfferDetail'
      }, {
        boardSeq: params.boardSeq,
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 구인 게시판 게시글 등록
  setBoardJobOfferWrite(form: any): Promise<any> {
    return this.restful.post({
      program: 'home',
      service: 'job',
      version: '1.0',
      action: 'setBoardJobOfferWrite'
    }, form.value
  ).then(this.restful.extractData)
   .catch(this.restful.handleErrorPromise);
  }

  // 구인 게시판 게시글 수정
  setBoardJobOfferModify(form: any): Promise<any> {
    return this.restful.post({
      program: 'home',
      service: 'job',
      version: '1.0',
      action: 'setBoardJobOfferModify'
    }, form.value
  ).then(this.restful.extractData)
   .catch(this.restful.handleErrorPromise);
  }

  // 구인 게시판 게시글 삭제
  setBoardJobOfferDelete(params: any): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'job',
        version: '1.0',
        action: 'setBoardJobOfferDelete'
      }, {
        board_seq: params.boardSeq,
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }
  // #endregion "구인"

  // #region "구직"
  // 구직 게시판 리스트를 가져온다.
  getBoardJobSearchList(params: any): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'job',
        version: '1.0',
        action: 'getBoardJobSearchList'
      }, {
        no: params.no,
        row: params.row,
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 구직 게시판 상세정보를 가져온다.
  getBoardJobSearchDetail(params: any): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'job',
        version: '1.0',
        action: 'getBoardJobSearchDetail'
      }, {
        boardSeq: params.boardSeq,
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 구직 게시판 게시글 등록
  setBoardJobSearchWrite(form: any): Promise<any> {
    return this.restful.post({
      program: 'home',
      service: 'job',
      version: '1.0',
      action: 'setBoardJobSearchWrite'
    }, form.value
  ).then(this.restful.extractData)
    .catch(this.restful.handleErrorPromise);
  }

  // 구직 게시판 게시글 수정
  setBoardJobSearchModify(form: any): Promise<any> {
    return this.restful.post({
      program: 'home',
      service: 'job',
      version: '1.0',
      action: 'setBoardJobSearchModify'
    }, form.value
  ).then(this.restful.extractData)
    .catch(this.restful.handleErrorPromise);
  }

  // 구직 게시판 게시글 삭제
  setBoardJobSearchDelete(params: any): Promise<any> {
    return this.restful.get({
        program: 'home',
        service: 'job',
        version: '1.0',
        action: 'setBoardJobSearchDelete'
      }, {
        board_seq: params.boardSeq,
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }
  // #endregion "구직"
}
